import { Users, Mail, Building2, GraduationCap, Package } from "lucide-react";

const CARDS = [
  { key: "applications", label: "Applications", icon: Users, accent: "bg-blue-500" },
  { key: "new_applications", label: "New", icon: Users, accent: "bg-orange-500" },
  { key: "partner_inquiries", label: "Partners", icon: Building2, accent: "bg-purple-500" },
  { key: "contact_inquiries", label: "Contacts", icon: Mail, accent: "bg-teal-500" },
  { key: "programs", label: "Programs", icon: GraduationCap, accent: "bg-indigo-500" },
  { key: "packages", label: "Packages", icon: Package, accent: "bg-emerald-500" },
];

function StatCard({ Icon, label, value, accent }) {
  return (
    <div className="rounded-2xl bg-white border border-slate-100 p-4">
      <div className={`w-8 h-8 rounded-lg ${accent} text-white grid place-items-center mb-2`}>
        <Icon className="w-4 h-4" />
      </div>
      <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">{label}</p>
      <p
        className="text-2xl font-extrabold text-slate-900 tabular-nums"
        style={{ fontFamily: "'Inter', system-ui, sans-serif" }}
      >
        {value}
      </p>
    </div>
  );
}

export default function AdminStatsBar({ stats }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-3 mb-8" data-testid="admin-stats">
      {CARDS.map((c) => (
        <StatCard key={c.key} Icon={c.icon} label={c.label} value={stats[c.key]} accent={c.accent} />
      ))}
    </div>
  );
}
